/*! Wi-user - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var url_user;

+function ($) {
    'use strict';
    var wiUser = window.wiUser;
    window.wiUser = {
        init: function () {
            wiUser.is_logged();
            wiUser.events();
            wiUser.register();
            wiUser.login();
        },
        refresh: function () {
        },
        events: function () {
            $(document).on('click', '.show-login-modal', function (e) {
                e.preventDefault();
                var th = $(this);
                var uid = th.parent().parent().attr('id');
                var id = th.parent().parent().data('id');
                var type = th.parent().parent().data('type');
                $('#comments_modal').modal('hide');
                wiModal.get({
                    modal: 'login_modal',
                    module: 'user',
                    lang_id: language_id,
                    uid: uid,
                    parent_id: 0,
                    referral_id: id,
                    referral_type: type,
                    remove: true
                });
            });
            $(document).on('click', '.show-register-modal', function (e) {
                e.preventDefault();
                var th = $(this);
                var uid = th.parent().parent().attr('id');
                var id = th.parent().parent().data('id');
                var type = th.parent().parent().data('type');
                $('#login_modal').modal('hide');
                wiModal.get({
                    modal: 'register_modal',
                    module: 'user',
                    lang_id: language_id,
                    uid: uid,
                    parent_id: 0,
                    referral_id: id,
                    referral_type: type,
                    remove: true
                });
            });
        },
        login: function () {
            $(document).on('submit', '.login-form', function (e) {
                e.preventDefault();
                wiLayout.loader('show');
                var th = $(this);
                th.prop("disabled", true);
                var form_data = th.serialize();
                $.ajax({
                    url: url_user + '/form/login/' + language_id,
                    type: 'POST',
                    data: form_data,
                    success: function (data) {
                        if (data.status === 'success') {
                            if (data.redirect) {
                                location.href = data.redirect;
                            } else {
                                location.reload();
                            }
                        }
                        th.find('.validation').html(data.msg);
                        wiLayout.loader('remove');
                        th.prop("disabled", false);
                    }
                });
            });
        },
        register: function () {
            $(document).on('submit', '.register-form', function (e) {
                e.preventDefault();
                wiLayout.loader('show');
                var th = $(this);
                th.prop("disabled", true);
                var form_data = th.serialize();
                $.ajax({
                    url: url_user + '/form/register/' + language_id,
                    type: 'POST',
                    data: form_data,
                    success: function (data) {
                        if (data.status === 'success') {
                            location.reload();
                        }
                        th.find('.validation').html(data.msg);
                        wiLayout.loader('remove');
                        th.prop("disabled", false);
                    }
                });
            });
        },
        is_logged: function () {
            var id = $('body').attr('id');
            var menu = $('#menu');
            $.get(url_user + '/is-logged', {id: id, lang_id: language_id}, function (data) {
                if (data.admin) {
                    $('body').prepend(data.adminMenu);
                    if (!$('body').hasClass('adminbar')) {
                        $('body').addClass('adminbar');
                    }
                }
                if (data.menuLink) {
                    if (menu.find('.navbar-user-menu').length) {
                        menu.find('.navbar-user-menu').replaceWith(data.menuLink);       
                    }
                    else {                 
                        menu.append(data.menuLink); 
                    }

                }
                if (data.csrf) {
                    $('.csrf_wicode').val(data.csrf);
                    $('[name="wi:csrf"]').attr('content', data.csrf);
                }
            });
        },
        cart: function () {
            $.get('/shop/cart-value', function (data) {
                if ($('#cartDropdown').length) {
                    $('#cartDropdown').remove();
                }
                $('#cart-value').html(data.value);
                $('#cart-link').append(data.menu);
                $("[data-toggle='tooltip']").tooltip();
            });
        }

    };
    $(function () {
        url_user = urls.user;
        wiUser = window.wiUser;
        wiUser.init();
    });
}(jQuery);
